Object.defineProperty(exports, '__esModule', {
  value: true
});
var _tslib = require('../_tslib-1246030c.js');
var dateFns = require('date-fns');
require('date-fns/locale/en-GB');
var formatting_utils_dateFnsHelpers = require('./utils/dateFnsHelpers.js');
var formatDate = function formatDate(date) {
  return date && date.toISOString();
};
var formatDateLong = function formatDateLong(date) {
  return dateFns.format(date, "dd/MM/yyyy | HH:mm");
};
var formatDateShort = function formatDateShort(date) {
  return dateFns.format(date, "dd/MM/yyyy");
};
var formatDistance = function formatDistance(date, baseDate, options) {
  if (options === void 0) {
    options = {};
  }
  return dateFns.formatDistance(date, baseDate, _tslib.__assign(_tslib.__assign({}, options), {
    locale: formatting_utils_dateFnsHelpers.overwrittenLocale
  }));
};
var formatTime = function formatTime(date) {
  return dateFns.format(date, "HH:mm");
};
exports.formatDate = formatDate;
exports.formatDateLong = formatDateLong;
exports.formatDateShort = formatDateShort;
exports.formatDistance = formatDistance;
exports.formatTime = formatTime;